import { useMemo } from 'react';

import { useGetOrganizationCollectionEndpoint } from '../../../queries';

export interface HotelOption {
  /** Id dokumentu w `hotels` (= id organizacji) — trafia do `assigned_hotels`. */
  id: string;
  name: string;
  city: string;
  code: string;
}

/**
 * Hotele do przypisania reklamy.
 *
 * Lista idzie z `organizations`, bo tylko tam jest miasto i kod. Id hotelu to
 * WPROST id organizacji — `getOrganizationsCollection` czyta hotel przez
 * `hotels/{orgId}`, więc obie kolekcje dzielą przestrzeń identyfikatorów.
 * Pole `hotel` z odpowiedzi to NAZWA hotelu (`hotels/{id}.name`), nie id —
 * użycie go jako identyfikatora wysyłało do backendu napisy zamiast id
 * i cała lista lądowała w `skipped`.
 */
export const useHotelOptions = () => {
  const query = useGetOrganizationCollectionEndpoint();

  const hotels = useMemo<HotelOption[]>(() => (query.data ?? [])
    .map((org) => ({
      id: org.id,
      name: org.hotel || org.name || org.companyName || org.id,
      city: org.city || org.companyCity || '',
      code: org.code || '',
    }))
    .filter((hotel) => !!hotel.id)
    .sort((a, b) => a.name.localeCompare(b.name, 'pl')), [query.data]);

  const hotelNameById = useMemo(
    () => new Map(hotels.map((hotel) => [hotel.id, hotel.name])),
    [hotels],
  );

  return { hotels, hotelNameById, isLoading: query.isLoading, error: query.error };
};
